import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BouncedCharge } from '../../Models/Domains/Transactions/Investments/BouncedCharge';

declare var IS_RUNNING_IN_APP_POOL;

export class DisinvestEventChargeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(orderId: number): Promise<Array<BouncedCharge>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/DisinvestEventCharge/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { orderId: orderId }

    return AjaxWrapper.get<Array<BouncedCharge>, any>(url, data);
  }
}

